<div class="row">
  <div class="col-md-12">
    <p class="text-center font-weight-bold sb-b p-1">Create a 2030 Goals Outcome</p>
  </div>
</div>

<app-tnc-goals-standalone-panel></app-tnc-goals-standalone-panel>
